import { BLUE_RIBBON_700, NEUTRAL_100, SKY_BLUE, WHITE } from "@styles/colors";
import { GIVONIC } from "@styles/fonts";
import styled from "styled-components";

const BASE_URL = 'https://s3.ap-southeast-3.amazonaws.com/assets.jagad.to/ppob/services'

const phoneCreditServiceUrl = `${BASE_URL}/ServicePhoneCreditIcon.svg`
const mobileDataServiceUrl = `${BASE_URL}/ServiceMobileDataIcon.svg`
const esimDataServiceUrl = `${BASE_URL}/ServiceESIMDataIcon.svg`
const esimCreditServiceUrl = `${BASE_URL}/ServiceESIMCreditIcon.svg`
const bpjsServiceUrl = `${BASE_URL}/ServiceBPJSIcon.svg`
const plnServiceUrl = `${BASE_URL}/ServicePLNIcon.svg`
const cableTVServiceUrl = `${BASE_URL}/ServiceCableTVIcon.svg`
const pdamServiceUrl = `${BASE_URL}/ServicePDAMIcon.svg`
const etollServiceUrl = `${BASE_URL}/ServiceETollIcon.svg`
const buyESIMServiceUrl = `${BASE_URL}/ServiceBuyESIMIcon.svg`

// Container component
export const Container = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: ${SKY_BLUE};
    padding-bottom: 10vh;
`;

// Title component
export const Title = styled.span`
    font-family: ${GIVONIC.bold};
    color: ${BLUE_RIBBON_700};
    width: 100%;
    text-align: center;
    font-size: 24px;
    margin-top: 20px;
`;

// PageWrapper component
export const PageWrapper = styled.div`
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: column;
`;

// ContentContainer component
export const ContentContainer = styled.div`
    position: relative;
    top: -6vh;
    padding-left: 12px;
    padding-right: 12px;
    overflow-y: auto;
`;

// Service icon components
export const PhoneCreditServiceIcon = styled.img.attrs({ src: phoneCreditServiceUrl })``
export const MobileDataServiceIcon = styled.img.attrs({ src: mobileDataServiceUrl })``
export const ESIMDataServiceIcon = styled.img.attrs({ src: esimDataServiceUrl })``
export const ESIMCreditServiceIcon = styled.img.attrs({ src: esimCreditServiceUrl })``
export const BPJSServiceIcon = styled.img.attrs({ src: bpjsServiceUrl })``
export const PLNServiceIcon = styled.img.attrs({ src: plnServiceUrl })``
export const CableTVServiceIcon = styled.img.attrs({ src: cableTVServiceUrl })``
export const PDAMServiceIcon = styled.img.attrs({ src: pdamServiceUrl })``
export const ETollServiceIcon = styled.img.attrs({ src: etollServiceUrl })``
export const BuyESIMServiceIcon = styled.img.attrs({ src: buyESIMServiceUrl })``

// ServiceButtonsWrapper component
export const ServiceButtonsWrapper = styled.div`
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    justify-content: center;
    justify-items: center;
    align-items: start;
    gap: 16px;
    width: 100%;
`;

// ServiceContainer component
export const ServiceContainer = styled.div`
    background-color: ${WHITE};
    border-radius: 16px;
    border: 1px solid ${NEUTRAL_100};
    padding: 20px 16px 24px 16px;
`;

// EmptyStateText component
export const EmptyStateText = styled.div`
    font-family: ${GIVONIC.regular};
    color: ${BLUE_RIBBON_700};
    font-size: 16px;
    text-align: center;
    padding: 40px 20px;
`;
